import { useNavigate } from "react-router-dom";
import Button from "../Buttons/Button";

const Terminated = ({ title, description, restart, link }) => {
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate(link);
  };
  return (
    <div className="px-8 py-20">
      <p className="text-3xl font-semibold mb-7">{title}</p>      
        <ul className="flex flex-col gap-2 font-medium text-neutral-400 break-keep">
          {description.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>      

      {restart && (
        <div className="fixed left-0 w-full bottom-10 p-inner">
          <Button onClick={handleOnClick}>서비스 재시작</Button>
        </div>
      )}
    </div>
  );
};

export default Terminated;
